import React from "react";
import PageHeader, { PageCTA } from "../components/PageHeader";
import Ebooks from "../components/Ebooks";

export default function EbooksPage() {
  return (
    <div data-testid="page-ebooki">
      <PageHeader
        eyebrow="E-booki & Kursy"
        title={
          <>
            Buduję wiedzę, która{" "}
            <span className="gold-gradient-text italic">realnie działa</span>
          </>
        }
        subtitle="E-booki, kursy i poradniki dla osób, które chcą rozwijać się w branży transportowej. Sprzedaż i dostęp do materiałów przez platformę naffy.io."
      />
      <Ebooks />
      <PageCTA
        title="Nie wiesz od czego zacząć?"
        text="Jeśli szukasz materiału dopasowanego do Twojej sytuacji — napisz, doradzę który kurs lub e-book będzie dla Ciebie najlepszy."
        buttonLabel="Zapytaj o materiały"
        to="/kontakt"
      />
    </div>
  );
}
